import React, { useState } from "react";

import Footer from "../../../../components/common/Footer";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import MultiSelect from "../../../../components/common/MultiSelect";

import {
  Button,
  Col,
  Collapse,
  Input,
  Radio,
  Row,
  Space,
  TreeSelect,
} from "antd";

import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiCloseCircleLine,
} from "react-icons/ri";
import { MdAddCircle } from "react-icons/md";

import { ownerPackets, properties } from "./data";

import "./BulkUpdateOwnerPacketSettings.css";

const { Panel } = Collapse;

const PacketSettingsRightBar = [];

function BulkUpdateOwnerPacketSettings() {
  const [value, setValue] = useState("all");
  const [fieldValue, setFieldValue] = useState("add");
  const [disabled, setDisabled] = useState(true);
  const [inputForm, setInputForm] = useState([
    { id: 1, radioValue: "", selValue: "" },
  ]);
  const [selectValue, setSelectValue] = useState("");
  const [selectValues, setSelectValues] = useState([]);

  const handleDelete = (id) => {
    const newArr = inputForm.filter((item) => {
      return item.id !== id;
    });
    setInputForm(newArr);
  };

  const onSelectChange = (newValue) => {
    console.log(newValue);
    setSelectValue(newValue);
    selectValues.push(newValue);
  };

  const handleInputChange = (id) => {
    const values = [...inputForm];
    const index = values.findIndex((field) => field.id === id);
    values[index].selValue = selectValue;
    setInputForm(values);
  };

  const handleAddFields = () => {
    const values = [...inputForm];
    const nextId = inputForm[inputForm.length - 1].id + 1;
    values.push({ id: nextId, radioValue: "", selValue: "" });
    setInputForm(values);
  };

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
    if (value === "specific-packets") {
      setDisabled(true);
    }
    if (value === "all") {
      setDisabled(false);
    }
  };

  const onFieldChange = (e) => {
    setFieldValue(e.target.value);
  };
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Bulk Update Owner Packet Settings" />
          <Row gutter={[0, 24]} className="packet-settings">
            <Col span={24} className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
              >
                <Panel
                  header="Select which owner packets you want to update"
                  key="1"
                >
                  <Row gutter={[0, 16]}>
                    <Col span={24}>
                      <Radio.Group onChange={onChange} value={value}>
                        <Space direction="vertical">
                          <Radio value="all">All</Radio>
                          <Radio value="specific-packets">
                            Select specific owner packets
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </Col>
                    <Col span={24}>
                      <MultiSelect
                        options={properties}
                        placeholder="Select by properties, units, compaigns"
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
            </Col>
            <Col span={24} className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
              >
                <Panel header="Select which fields to change" key="1">
                  <Row gutter={[0, 24]}>
                    <Col span={24}>
                      <p>
                        Select which owner packet fields you would like to
                        change:
                      </p>
                    </Col>
                    {inputForm.map((item, index) => {
                      return (
                        <Col span={24} key={index} className="row">
                          <Row gutter={[40, 0]} align="middle">
                            <Col span={11}>
                              <TreeSelect
                                style={{
                                  width: "100%",
                                }}
                                value={inputForm.selValue}
                                dropdownStyle={{
                                  maxHeight: 400,
                                  overflow: "auto",
                                }}
                                treeData={ownerPackets}
                                placeholder="Please select..."
                                treeDefaultExpandAll
                                onChange={onSelectChange}
                                onSelect={() => handleInputChange(item.id)}
                              />
                            </Col>
                            <Col span={2}>
                              <p>To</p>
                            </Col>
                            {item.selValue !== "" ? (
                              <Col span={9}>
                                <Radio.Group
                                  onChange={onFieldChange}
                                  value={fieldValue}
                                >
                                  <Space direction="vertical">
                                    <Radio value="add">Add</Radio>
                                    <Radio value="remove">Remove</Radio>
                                  </Space>
                                </Radio.Group>
                              </Col>
                            ) : (
                              <Col span={9}>
                                <Input
                                  placeholder="Please select a field first"
                                  disabled={true}
                                />
                              </Col>
                            )}
                            {inputForm.length > 1 ? (
                              <Col span={2}>
                                <button
                                  className="delete-btn"
                                  onClick={() => handleDelete(item.id)}
                                >
                                  <RiCloseCircleLine size={20} />
                                </button>
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      );
                    })}
                    <Col span={24}>
                      <button
                        className="add-icon-btn"
                        onClick={() => handleAddFields()}
                      >
                        <MdAddCircle size={18} />
                        <span>Add More</span>
                      </button>
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
            </Col>
            <Col span={24} className="collapse-container">
              <Collapse
                expandIcon={({ isActive }) =>
                  isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                }
              >
                <Panel header="Confirm your changes" key="1">
                  <Row gutter={[0, 24]}>
                    {selectValues.length >= 1 ? (
                      <Col span={24}>
                        <Row gutter={[0, 24]}>
                          <Col span={24}>
                            <Row>
                              <Col span={24}>
                                <strong>Please review</strong>
                              </Col>
                              <Col span={24}>
                                <p>
                                  For <strong>all</strong> owners, you are:
                                </p>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Row className="before">
                              <Col span={24}>
                                <h2>{selectValues.length}</h2>
                              </Col>
                              <Col span={24}>
                                <span>
                                  {fieldValue === "add" ? "Adding" : "Removing"}{" "}
                                </span>
                                {selectValues.map((i, index) => {
                                  return (
                                    <>
                                      <span index={index}>{i} </span>{" "}
                                      {index === selectValues.length - 2 ? (
                                        <span>and </span>
                                      ) : (
                                        <span>,</span>
                                      )}
                                    </>
                                  );
                                })}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      <Col span={24}>
                        <p>
                          Please select which field you would like to update.
                        </p>
                      </Col>
                    )}
                    <Col span={24}>
                      <Button type="primary">Update Packets</Button>
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
            </Col>
          </Row>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PacketSettingsRightBar} />
      </div>
    </>
  );
}

export default BulkUpdateOwnerPacketSettings;
